<!-- login.component.html -->
<div class="login-container">
  <mat-card class="login-card">
    <div class="logo">
      <img src="../../assets/images/berkeley_logo.png" alt="Berkeley Logo" />
    </div>
    <h2 class="title pt-2">ALS Safety Configuration Control</h2>
    <h4 class="subtitle">Berkeley Lab Identity Required</h4>
    <p class="instruction">
      Click on Login Button to Proceed or Request for a User Account
    </p>

    <button mat-flat-button class="full-width" (click)="login()">Login</button>

    <a class="help-link" href="{{ url }}">Request User Account?</a>
  </mat-card>

  <div class="login-footer">
    <div class="footer-left">
      <img src="../../../assets/images/DOEseal.png" alt="DOE Seal" />
      <img src="../../../assets/images/BerkeleySeal.png" alt="Berkeley Seal" />

      <span>
        A U.S. Department of Energy National Laboratory<br />Managed by the
        University of California
      </span>
    </div>
    <div class="footer-right">
      <a href="#">Questions & Comments</a>
      <a href="#">Privacy & Security Notice</a>
    </div>
  </div>
</div>

<!-- <button mat-flat-button color="primary" (click)="login()">Login</button> -->
